import { Component } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import {
  ViewProfileService,
} from 'src/app/shared/services/view-profile-servies/view-profile.service';

@Component({
  selector: 'app-contact-details',
  templateUrl: './contact-details.component.html',
  styleUrls: ['./contact-details.component.css'],
})
export class ContactDetailsComponent {
  contactForm: FormGroup = new FormGroup({
    mobile: new FormControl('', ),
    address: new FormControl('', ),
    telephoneNo: new FormControl('',),
    state: new FormControl('',),
    city: new FormControl(''),
    postalCode: new FormControl('', [ Validators.pattern('[0-9]{6}')]),
    country: new FormControl('',),
  });

  constructor(
    private formBuilder: FormBuilder,
    private profileService: ViewProfileService
  ) {}
  contact: any | undefined;

  setFormState(value: boolean) {
    if (value == true) {
      this.contactForm.enable();
    } else {
      this.contactForm.disable();
    }
  }
  ngOnInit(): void {
    this.profileService.getProfile().subscribe((data) => {
      this.contactForm?.controls['mobile'].setValue(data.data.phone);
      this.contactForm?.controls['address'].setValue(data.data.address);
      // this.contactForm?.controls['telephoneNo'].setValue(data.data.);
      this.contactForm?.controls['state'].setValue(
        Object.keys(data.data.state).length ? data.data.state : ''
      );
      this.contactForm?.controls['city'].setValue(
        Object.keys(data.data.city).length ? data.data.city : ''
      );
      this.contactForm?.controls['postalCode'].setValue(data.data.pincode);
      // this.contactForm?.controls['country'].setValue(data.data.);
    });
    this.setFormState(false);
  }

  keyPressNumbers(event: any) {
    console.log(event);
    var charCode = event.which ? event.which : event.keyCode;
    // Only Numbers 0-9
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
      return false;
    } else {
      return true;
    }
  }

}
